const o = (t) => {
  const r = t > 99.99 ? Math.floor(t) : t;
  return r % 1 !== 0 ? r.toFixed(2).replace(".", ",") : r.toString();
}, c = (t) => t.replace(/(<([^>]+)>)/gi, ""), a = (t) => t.replace(/&#?([a-z0-9]){1,};/gi, "");
function e(t) {
  return t.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL"
  });
}
function i(t) {
  return e(t).replace(/^R\$/, "").replace(/\s/, "");
}
export {
  e as getCurrencyString,
  i as getFormattedPrice,
  o as getPriceString,
  a as removeNotParsedHtmlSymbols,
  c as stripTags
};
